export default {
    // Navbar
    nav: {
      home: 'Strona główna',
      about: 'O mnie',
      strategies: 'Strategie',
      performance: 'Wyniki',
      portfolioBuilder: 'Kreator portfela',
      insights: 'Analizy',
      reports: 'Raporty tygodniowe',
      terminal: 'Quant Lab',
      contact: 'Kontakt',
      institutional: 'Inwestorzy instytucjonalni',
    },
    
    // Home Page
    home: {
      ticker: {
        subtitle: 'Handel kwantowy · Strategie systematyczne',
      },
      hero: {
        title: 'HMA Quant Strategies',
        description: 'Analityk kwantowy opracowujący algorytmiczne strategie z roczną stopą zwrotu przekraczającą',
        cagr: '40% CAGR',
        and: 'i',
        sharpe: 'Sharpe > 1.5',
        additionalPrefix: 'Z',
        drawdowns: 'drawdowns',
        additionalMiddle: 'poniżej',
        drawdownValue: '15%',
        additionalAnd: 'oraz danymi historycznymi obejmującymi ponad',
        years: '20 lat',
        ctaPrimary: 'Odkryj strategie',
        ctaSecondary: 'O mnie',
      },
      featured: {
        label: 'Wyróżniona strategia',
        cta: 'Odkryj ARES →',
      },
      tech: {
        label: 'Infrastruktura kwantowa',
        title: 'NARZĘDZIA MATEMATYCZNE I ',
        titleAccent: 'KOMPUTEROWE',
        footer: 'Strategie systematyczne zwalidowane poprzez rygorystyczny backtesting na danych instytucjonalnych',
      },
      timeline: {
        label: 'Ścieżka zawodowa',
        title: 'KAMIENIE ',
        titleAccent: 'MILOWE KARIERY',
        milestones: [
          {
            title: 'Studia z fizyki',
            description: 'Ukończenie studiów uniwersyteckich ze specjalizacją w fizyce teoretycznej i matematyce stosowanej.',
          },
          {
            title: 'Magisterium z finansów kwantowych',
            description: 'Specjalistyczne szkolenie w zakresie modelowania matematycznego, analizy kwantowej i opracowywania strategii algorytmicznych.',
          },
          {
            title: 'Fundusz hedgingowy + strategia algorytmiczna',
            description: 'Rozpoczęcie pracy w hiszpańskim funduszu hedgingowym. Opracowanie i wdrożenie algorytmicznej strategii opartej na dywidendach.',
          },
          {
            title: 'IG Group (FTSE 100)',
            description: 'Dołączenie do brokera IG Group, spółki z indeksu FTSE 100, praca w rozwoju kwantowym.',
          },
          {
            title: 'Strategie w produkcji',
            description: 'Wiele strategii algorytmicznych wdrożonych do produkcji z rzeczywistym kapitałem. Portfel systematycznego handlu w pełni operacyjny.',
          },
        ],
      },
      features: {
        title: 'Dlaczego inwestować w strategie kwantowe?',
        subtitle: 'Systemy algorytmiczne oparte na danych, rygorystycznym backtestingu i instytucjonalnym zarządzaniu ryzykiem',
        items: [
          {
            title: 'Momentum i timing',
            description: '+40% CAGR w strategiach momentum i market timing zwalidowanych na 15 latach danych historycznych'
          },
          {
            title: 'Modele bayesowskie',
            description: 'Ukryte modele Markowa do wykrywania reżimu rynkowego i dynamicznej adaptacji'
          },
          {
            title: 'Neutralność rynkowa',
            description: 'Strategie long-short z analizą korelacji Beta/R² w celu redukcji ekspozycji kierunkowej'
          },
          {
            title: 'Systemy zautomatyzowane',
            description: 'W pełni automatyczny handel intraday w firmach prop oraz u brokerów instytucjonalnych'
          },
          {
            title: 'Multi-asset',
            description: 'Akcje USA, indeksy, krypto, zmienność (VIX) - prawdziwa dywersyfikacja'
          },
          {
            title: 'Doświadczenie instytucjonalne',
            description: 'Doświadczenie w zarządzaniu portfelami do $200M w funduszach hedgingowych i brokerach FTSE 100'
          }
        ]
      },
      cta: {
        title: 'Gotowy, aby zacząć?',
        subtitle: 'Odkryj moje strategie na Darwinex, eToro i Wikifolio, lub czytaj moje analizy kwantowe na Substack',
        ctaPrimary: 'Gdzie inwestować',
        ctaSecondary: 'Kontakt'
      }
    },

    // About Me Page
    about: {
      title: 'Analityk kwantowy',
      intro1: 'Analityk kwantowy z wykształceniem w zakresie',
      physics: 'fizyki (BSc)',
      and: 'i',
      finance: 'finansów kwantowych (MSc)',
      intro2: '. Obecnie pracuje w londyńskim brokerze (FTSE 100), rozwijając modele statystyczne i systematyczne strategie handlowe.',
      intro2b: 'Obecnie kandydat do CFA (Chartered Financial Analyst) — najbardziej prestiżowego i globalnie uznawanego certyfikatu w branży inwestycyjnej.',
      intro3: 'Z wcześniejszym doświadczeniem w zarządzaniu portfelami do',
      amount: '$200M w hiszpańskim funduszu hedgingowym',
      intro4: ', oraz w wycenie i zarządzaniu ryzykiem instrumentów pochodnych energii w funduszu towarowym, łączy rygor matematyczny, machine learning i głęboką wiedzę rynkową w celu budowy odpornych i powtarzalnych algorytmów.',
      trackRecordTitle: 'Osiągnięcia',
      trackRecordDescription: 'Budowanie strategii kwantowych, które generują spójne zwroty skorygowane o ryzyko w każdym reżimie rynkowym. Nasze osiągnięcia mówią poprzez liczby: niezależne strategie zaprojektowane w celu minimalizacji drawdowns przy jednoczesnej maksymalizacji alpha, każda przetestowana na dekadach danych historycznych i zwalidowana poprzez live paper trading i rzeczywisty handel. Indywidualnie, każda strategia dąży do kontrolowanego ryzyka w ramach swojej klasy aktywów. Połączone w zdywersyfikowany portfel, osiągają wskaźniki Sharpe powyżej 1,5 i maksymalne drawdowns poniżej -15%, z niemal zerową korelacją do tradycyjnych benchmarków. Od portfeli akcji opartych na momentum do neutralnej rynkowo arbitrażu statystycznego, od zbierania zmienności do kwantowego makro, niezależnie od tego, czy jesteś inwestorem detalicznym poszukującym systematycznej ekspozycji, czy instytucją poszukującą nieskorelowanych strumieni zwrotu, budujemy strategie dostosowane do Państwa profilu ryzyka i celów.',
      trackRecordParagraph1: 'Budowanie strategii kwantowych, które generują spójne zwroty skorygowane o ryzyko w różnych reżimach rynkowych. Doświadczenie zawodowe obejmuje optymalizację strategii systematycznych, poprawę zwrotów skorygowanych o ryzyko z 12% do 23% w ujęciu rocznym oraz wkład w zarządzanie portfelami i badania obejmujące aktywa pod zarządzaniem przekraczające €200M.',
      trackRecordParagraph2: 'Zaprojektował i przetestował ponad 40 modeli kwantowych w akcjach, instrumentach pochodnych i papierach wartościowych o stałym dochodzie. Każda strategia została przetestowana na dekadach danych historycznych oraz zwalidowana poprzez live paper trading i rzeczywiste warunki rynkowe.',
      trackRecordParagraph3: 'Indywidualnie, każda strategia dąży do kontrolowanego ryzyka w ramach swojej klasy aktywów. Połączone w zdywersyfikowany portfel, osiągają wskaźniki Sharpe powyżej 1,5 i maksymalne drawdowns poniżej -15%, z niemal zerową korelacją do tradycyjnych benchmarków.',
      trackRecordDisclaimer: 'Wyniki oparte na backtestingu i live paper trading. Przeszłe wyniki nie gwarantują przyszłych zwrotów. Wszystkie zwroty są hipotetyczne, chyba że wyraźnie określono jako rzeczywiste.',
      trackRecordParagraph4: 'Od portfeli akcji opartych na momentum do neutralnego rynkowo arbitrażu statystycznego, od zbierania zmienności do kwantowego makro, niezależnie od tego, czy jesteś inwestorem detalicznym poszukującym systematycznej ekspozycji, czy instytucją poszukującą nieskorelowanych strumieni zwrotu, budujemy strategie dostosowane do Państwa profilu ryzyka i celów.',
      expertiseTitle: 'Kompetencje',
      expertise: [
        '+40% CAGR w strategiach momentum i timing',
        'Modele bayesowskie z ukrytymi modelami Markowa do wykrywania reżimu',
        'Strategie neutralne rynkowo z analizą korelacji Beta/R²',
        'W pełni automatyczne systemy intraday dla firm prop',
        'Multi-asset: akcje USA, indeksy, krypto, zmienność (VIX)',
        'Doświadczenie instytucjonalne: zarządzanie portfelami do $200M',
      ],
      toolsTitle: 'Narzędzia matematyczne i komputerowe',
      toolsSubtitle: 'Technologie i frameworki, których używam do badań kwantowych i systematycznego handlu',
      clickToFlip: 'Kliknij, aby odwrócić',
      clickToFlipBack: 'Kliknij, aby powrócić',
      clickForDetails: 'Kliknij dla szczegółów →',
      clickToClose: 'Kliknij, aby zamknąć ←',
      tools: {
        python: {
          name: 'Python',
          description: 'Główny język do backtestingu, analizy statystycznej i rozwoju strategii'
        },
        numpy: {
          name: 'NumPy',
          description: 'Podstawowy pakiet do obliczeń numerycznych i operacji na tablicach'
        },
        pandas: {
          name: 'Pandas',
          description: 'Wysokowydajna manipulacja i analiza danych dla szeregów czasowych'
        },
        scikit: {
          name: 'Scikit-learn',
          description: 'Modele machine learning do rozpoznawania wzorców i analizy predykcyjnej'
        },
        tensorflow: {
          name: 'TensorFlow',
          description: 'Framework deep learning do modelowania złożonych zachowań rynkowych'
        },
        pytorch: {
          name: 'PyTorch',
          description: 'Dynamiczne sieci neuronowe do zaawansowanych badań deep learning'
        },
        git: {
          name: 'Git',
          description: 'Kontrola wersji do zarządzania kodem i rozwoju współpracy'
        },
        vscode: {
          name: 'VS Code',
          description: 'Profesjonalne IDE do efektywnego rozwoju kodu i debugowania'
        },
        jupyter: {
          name: 'Jupyter',
          description: 'Interaktywne notebooki do badań, wizualizacji i prototypowania strategii'
        },
        quantlib: {
          name: 'QuantLib',
          description: 'Biblioteka finansów kwantowych do wyceny instrumentów pochodnych i zarządzania ryzykiem'
        },
        backtrader: {
          name: 'Backtrader',
          description: 'Framework Pythona do backtestingu i live tradingu strategii'
        },
        postgresql: {
          name: 'PostgreSQL',
          description: 'Solidna relacyjna baza danych do przechowywania strukturalnych danych finansowych'
        },
        mongodb: {
          name: 'MongoDB',
          description: 'Baza danych NoSQL do elastycznego przechowywania nieustrukturyzowanych danych rynkowych'
        },
        docker: {
          name: 'Docker',
          description: 'Konteneryzacja dla spójnego wdrażania w różnych środowiskach'
        },
        aws: {
          name: 'AWS',
          description: 'Infrastruktura chmurowa do skalowalnego przetwarzania i przetwarzania danych'
        },
        mathematics: {
          name: 'Matematyka',
          description: 'Zaawansowane koncepcje matematyczne leżące u podstaw finansów kwantowych'
        },
        statistics: {
          name: 'Statystyka',
          description: 'Metody statystyczne do testowania hipotez i wnioskowania'
        },
        linearalgebra: {
          name: 'Algebra liniowa',
          description: 'Operacje macierzowe do optymalizacji portfela i modeli czynnikowych'
        },
        timeseries: {
          name: 'Szeregi czasowe',
          description: 'Analiza danych czasowych do prognozowania i wykrywania trendów'
        },
        calculus: {
          name: 'Rachunek różniczkowy',
          description: 'Pochodne i całki do wyceny opcji i optymalizacji'
        },
        probability: {
          name: 'Prawdopodobieństwo',
          description: 'Modele probabilistyczne do oceny ryzyka i podejmowania decyzji'
        },
        optimization: {
          name: 'Optymalizacja',
          description: 'Optymalizacja matematyczna do alokacji portfela i dostrajania strategii'
        },
        bayesian: {
          name: 'Bayesowski',
          description: 'Wnioskowanie bayesowskie do wykrywania reżimu i szacowania parametrów'
        },
        montecarlo: {
          name: 'Monte Carlo',
          description: 'Metody symulacyjne do analizy ryzyka i testowania scenariuszy'
        }
      },
      ctaTitle: 'Gotowy inwestować inaczej?',
      ctaSubtitle: 'Odkryj moje strategie kwantowe lub skontaktuj się ze mną.',
      ctaStrategies: 'Zobacz strategie',
      ctaContact: 'Kontakt',
      milestones: [
        {
          title: 'Studia z fizyki',
          description: 'Ukończenie studiów uniwersyteckich ze specjalizacją w fizyce teoretycznej i matematyce stosowanej.',
          shortDetail: 'Podstawy rachunku różniczkowego, algebry liniowej, mechaniki kwantowej, mechaniki statystycznej, elektromagnetyzmu, względności i programowania naukowego w Python/Fortran/C.'
        },
        {
          title: 'Magisterium z finansów kwantowych',
          description: 'Specjalistyczne szkolenie w zakresie modelowania matematycznego, analizy kwantowej i opracowywania strategii algorytmicznych.',
          shortDetail: 'Programowanie w Pythonie, ekonometria, instrumenty pochodne, zarządzanie portfelem, machine learning, deep learning, NLP, uczenie przez wzmacnianie, wdrożenie AWS i obliczenia kwantowe.'
        },
        {
          title: 'Fundusz hedgingowy',
          description: 'Dołączenie do hiszpańskiego funduszu hedgingowego, praca z najlepszymi klientami instytucjonalnymi.',
          shortDetail: 'Analityk kwantowy zarządzający portfelami dla Edmond de Rothschild, Millennium i firm amerykańskich. Studia oparte na danych, optymalizacja procesów i badania kwantowe.'
        },
        {
          title: 'Handel energią',
          description: 'Handel i zarządzanie ryzykiem na globalnych rynkach energii dla holenderskiej firmy.',
          shortDetail: 'Możliwości handlowe w europejskich połączeniach energetycznych. Projekty optymalizacyjne dla Repsol, Glencore, TMS. Reuters Eikon, rozwój ETRM, solvery CPLEX/Gurobi, wycena Monte Carlo.'
        },
        {
          title: 'IG Group (FTSE 100)',
          description: 'Analityk kwantowy w brokerze FTSE 100, rozwijający modele ML do optymalizacji handlu i zarządzania ryzykiem.',
          shortDetail: 'Modele XGBoost/Random Forest do zarządzania ryzykiem jako animator rynku. Badania statystyczne, pipeline PnL, dashboardy GCP/BigQuery/Streamlit. Raportowanie dla zespołów w Londynie i Melbourne.'
        },
        {
          title: 'Strategie w produkcji',
          description: 'Rozwój i działanie własnych strategii algorytmicznych z rzeczywistym kapitałem w wielu klasach aktywów.',
          shortDetail: 'Neutralne rynkowo, momentum, pair trading, handel oparty na ML, forex, krypto, strategie zmienności. Pełny pipeline od hipotezy do live execution. Zobacz sekcję Strategie dla szczegółów.'
        }
      ],
      eventsTitle: 'WYDARZENIA',
      eventsAttendTitle: 'WYDARZENIA, KTÓRE ODWIEDZAM / POLECAM',
      eventsOrganizeTitle: 'WYDARZENIA, KTÓRE ORGANIZUJĘ / NA KTÓRYCH MÓWIĘ',
      eventAttending: 'UCZESTNIK',
      eventOrganizer: 'ORGANIZATOR',
      eventQuantConference: 'Konferencja Finanse Kwantowe',
      eventQuantConferenceLocation: 'Londyn, czerwiec 2026',
      eventQuantConferenceDesc: 'Wiodące wydarzenie dla badaczy i praktyków kwantowych. Skupienie na systematycznym handlu i zarządzaniu ryzykiem.',
      eventQuantMeetup: 'Spotkanie Finanse Kwantowe',
      eventQuantMeetupLocation: 'Madryt, 2025',
      eventQuantMeetupDesc: 'Zorganizowane wydarzenie społecznościowe dla badaczy i praktyków kwantowych. Skupienie na dzieleniu się strategiami systematycznego handlu i networkingu.',
      eventsComingSoon: 'Więcej wydarzeń wkrótce...',
      podcastsTitle: 'PODCASTY · WKRÓTCE',
      podcastsDescription: 'Seria rozmów z praktykami, badaczami i twórcami w finansach kwantowych. Obecnie w planowaniu. Jeśli chcesz być powiadomiony, gdy to wystartuje, zapisz się przez stronę kontaktową.',
      disclaimer: 'Informacje przedstawione na tej stronie służą wyłącznie celom edukacyjnym i informacyjnym. Nie stanowią porady finansowej, inwestycyjnej ani handlowej. Przeszłe wyniki nie gwarantują przyszłych rezultatów. Zawsze konsultuj się z licencjonowanym doradcą finansowym przed podjęciem decyzji inwestycyjnych.',
    },

    // Strategies Page
    strategies: {
      title: 'Strategie kwantowe',
      subtitle: 'Systemy algorytmiczne poziomu instytucjonalnego z rygorystycznym backtestingiem',
      compareTitle: 'Porównanie wyników',
      compareSubtitle: 'Porównaj kluczowe wskaźniki wszystkich strategii',
      riskLevel: 'Poziom ryzyka',
      moderate: 'Umiarkowany',
      high: 'Wysoki',
      veryHigh: 'Bardzo wysoki',
      viewStrategy: 'Zobacz strategię',
      equityCurve: 'KRZYWA KAPITAŁU',
      drawdownAnalysis: 'ANALIZA DRAWDOWN',
      maxDrawdownComparative: 'PORÓWNANIE MAX DRAWDOWN',
      comparativeMetrics: 'WSKAŹNIKI PORÓWNAWCZE',
      correlation: 'KORELACJA',
      correlationWithBenchmarks: 'KORELACJA Z BENCHMARKAMI',
      downloadBrochure: '📄 Pobierz broszurę',
      annualReturns: 'Zwroty roczne',
      historicalDataDisclaimer: '* Dane historyczne okres {start} - {end}. Przeszłe wyniki nie gwarantują przyszłych zwrotów.',
      strategyNames: {
        tyr: 'Strategia TYR',
        ares: 'Strategia ARES',
        ascalafo: 'Strategia ASCÁLAFO',
        deimos: 'Strategia DEIMOS',
        fobos: 'Strategia FOBOS',
        bes: 'Strategia BES',
        janus: 'Strategia JANUS',
        hraesvelgr: 'Strategia HRÆSVELGR',
      },
      metrics: {
        cagr: 'CAGR',
        sharpe: 'Sharpe',
        maxDD: 'Max DD',
        volatility: 'Zmienność',
      },
      strategyDescriptions: {
        tyr: 'Rotacja podwójnego momentum',
        ares: 'Market timing',
        ascalafo: 'Podwójna warstwa',
        deimos: 'Market timing + ryzyko',
        fobos: 'Podwójna warstwa + ryzyko',
        bes: 'Podążanie za trendem',
        janus: 'Rotacja sektorowa',
        hraesvelgr: 'Agresywne All Weather',
      },
      strategyFullDescriptions: {
        tyr: 'TYR wzięła nazwę od nordyckiego boga porządku, sprawiedliwości i ochrony, odpowiedniego symbolu dla strategii zaprojektowanej do nawigacji rynków z dyscypliną i odpornością. TYR to kwantowa strategia rotacji podwójnego momentum inspirowana zasadami filozofii All Weather Ray Dalio.',
        ares: 'ARES to własna kwantowa strategia market timing. Opracowana i zwalidowana na prawie 20 latach danych historycznych (2006–2026), okazała się odporna przez najbardziej stresujące epizody współczesnych rynków: krach finansowy 2008, pandemię 2020, agresywny cykl podwyżek stóp w 2022 i ekstremalną zmienność 2024–2025.',
        ascalafo: 'Własna strategia market timing z podwójną warstwą na rynku amerykańskim. Dwa niezależne systemy sygnałów, które łączą się dla maksymalnej precyzji wejścia/wyjścia. 100% systematyczna, kontrolowana ekspozycja binarna.',
        deimos: 'DEIMOS to własna kwantowa strategia market timing z wyższym kontrolowanym ryzykiem. Opracowana i zwalidowana na prawie 20 latach danych historycznych (2006–2026), okazała się odporna przez najbardziej stresujące epizody współczesnych rynków. Z bardziej agresywnym profilem ryzyka niż ARES, dąży do maksymalizacji zwrotów na rynkach byka przy zachowaniu systematycznej dyscypliny.',
        fobos: 'Własna strategia market timing z podwójną warstwą na rynku amerykańskim z wysokim profilem ryzyko/zwrot. Dwa niezależne systemy sygnałów, które łączą się dla maksymalnej precyzji wejścia/wyjścia. 100% systematyczna, kontrolowana ekspozycja binarna ze zoptymalizowaną dźwignią dla inwestorów o wyższej tolerancji ryzyka.',
        bes: 'BES is a systematic trend-following strategy focused on medium-term growth. It holds names that are technically outrunning the broad market, combining relative strength, momentum and trend stability to filter noise.',
        janus: 'JANUS to kwantowy system selekcji akcji z pełnym tygodniowym rebalansowaniem, działający w trybie Long-Short Market Neutral. Jego nazwa przywołuje rzymskiego boga z dwiema twarzami — dokładnie dualność zajmowania pozycji długich i krótkich jednocześnie.',
        hraesvelgr: 'HRÆSVELGR is TYR’s more aggressive twin in the All Weather family. Same regime discipline, more appetite for growth, and a faster shift to defence when momentum fades.',
      },
    },

    // Portfolio Builder Page
    portfolioBuilder: {
      title: 'Kreator portfela',
      subtitle: 'Zbuduj swój spersonalizowany portfel łącząc wiele strategii kwantowych',
      riskWarning: {
        title: '⚠ OSTRZEŻENIE O RYZYKU',
        content: 'Strategie kwantowe wiążą się z ryzykiem utraty kapitału. Przedstawione wyniki historyczne oparte są na backtestingu i symulacji — nie gwarantują przyszłych zwrotów. To narzędzie edukacyjne, nie porada inwestycyjna, nie rekomendacja, ani zachęta do kupna lub sprzedaży papierów wartościowych.',
      },
      hero: {
        heading1: 'ZBUDUJ SWÓJ',
        heading2: 'IDEALNY PORTFEL',
        description: 'Odkryj kombinacje portfeli z naszymi strategiami. To narzędzie pozwala symulować alokacje, analizować wskaźniki historyczne i zrozumieć, jak różne wagi strategii wpływają na zwroty skorygowane o ryzyko. To narzędzie edukacyjne — nie spersonalizowana porada inwestycyjna.',
        disclaimer: 'Tylko narzędzie edukacyjne. Symulowane wyniki oparte na danych historycznych. Nie stanowi porady inwestycyjnej.',
      },
      tabs: {
        build: 'Zbuduj portfel',
        models: 'Portfele modelowe',
        saved: 'Zapisane portfele',
      },
      buildSection: {
        selectTitle: 'Wybierz strategie',
        selectSubtitle: 'Wybierz co najmniej 2 strategie do połączenia',
        weightsTitle: 'Przypisz wagi',
        weightsSubtitle: 'Suma musi wynosić 100%',
        totalWeight: 'Waga całkowita',
        distributeEqually: 'Rozkład równomiernie',
        optimize: 'Auto-optymalizacja (Sharpe)',
        generate: 'Generuj portfel',
        validationError: 'Wybierz co najmniej 2 strategie i upewnij się, że wagi sumują się do 100%',
        optimizeSuccess: 'Portfel zoptymalizowany z oczekiwanym Sharpe:',
        optimizeError: 'Błąd optymalizacji portfela',
      },
      modelsSection: {
        title: 'Portfele modelowe',
        subtitle: 'Wstępnie skonfigurowane portfele dla różnych profili ryzyka',
        usePortfolio: 'Użyj tego portfela',
        questionnaire: 'Wypełnij kwestionariusz',
      },
      savedSection: {
        title: 'Zapisane portfele',
        subtitle: 'Uzyskaj dostęp do wcześniej zapisanych konfiguracji portfela',
        noSaved: 'Brak jeszcze zapisanych portfeli',
        load: 'Załaduj',
        delete: 'Usuń',
      },
      results: {
        title: 'Wyniki portfela',
        composition: 'Skład portfela',
        metrics: 'Kluczowe wskaźniki',
        performance: 'Wyniki historyczne',
        returns: 'Zwroty miesięczne',
        exportPDF: 'Pobierz raport portfela',
        save: 'Zapisz portfel',
        saveSuccess: 'Portfel zapisany pomyślnie!',
        saveError: 'Błąd zapisu portfela',
        period: 'Okres',
        strategies: 'Strategie',
        tabs: {
          equity: 'Krzywa kapitału',
          drawdown: 'Drawdown',
          annual: 'Zwroty roczne',
        },
        metricLabels: {
          cagr: 'CAGR',
          totalReturn: 'Zwrot całkowity',
          sharpe: 'Sharpe',
          sortino: 'Sortino',
          maxDD: 'Max DD',
          calmar: 'Calmar',
          volatility: 'Zmienność',
          winRate: 'Wskaźnik wygranych',
          profitFactor: 'Współczynnik zysku',
          bestWeek: 'Najlepszy tydzień',
          worstWeek: 'Najgorszy tydzień',
        },
        quickStart: {
          model: 'Portfel modelowy',
          modelDesc: 'Odpowiedz na 5 pytań, a to narzędzie zaproponuje portfel modelowy na podstawie Twojej tolerancji ryzyka',
          models: 'Portfele modelowe',
          modelsDesc: 'Wybierz z 6 portfeli zaprojektowanych przez ekspertów: Konserwatywny, Umiarkowany, Agresywny i więcej',
          auto: 'Auto-optymalizacja',
          autoDesc: 'Algorytm znajduje optymalne wagi do automatycznej maksymalizacji wskaźnika Sharpe',
        },
        manual: {
          title: 'Kreator manualny',
          selectTitle: 'Wybierz strategie i przypisz wagi',
        },
      },
    },

    // Insights Page
    insights: {
      title: 'Analizy',
      subtitle: 'Strategie, analizy i zasoby dla inteligentnego inwestowania',
      substackSection: {
        title: 'NAJNOWSZE Z SUBSTACK',
        loading: 'Ładowanie najnowszych postów...',
        error: 'Nie udało się załadować artykułów. Spróbuj ponownie później.',
        errorWithLink: 'Najnowsze artykuły na Substack:',
      },
      newsletterTitle: 'HMA Quant Newsletter',
      visitSubstack: 'Odwiedź mój Substack',
      weeklyNewsletter: 'Newsletter tygodniowy',
      analysisAndNewsletter: 'Analiza i newsletter',
      subscribe: 'Zapisz się',
      newsletterIntro: 'Dzielę się analizami kwantytatywnymi, tezami inwestycyjnymi i codziennymi notatkami na temat mapy opcji S&P500 na moim Substack',
      newsletterDescription: 'Otrzymuj głębokie analizy techniczne, kwantytatywne tezy inwestycyjne i codzienną mapę opcji S&P500 bezpośrednio na swój email. Ekskluzywne treści dla traderów poszukujących przewagi informacyjnej.',
      newsletterBadge1: 'Analiza kwantytatywna',
      newsletterBadge2: 'Mapa opcji',
      newsletterBadge3: 'Tezy inwestycyjne',
      whereToInvestTitle: 'Gdzie inwestować',
      whereToInvestSubtitle: 'Możesz śledzić moje strategie kwantowe na następujących regulowanych platformach. Każda strategia ma swój własny profil ryzyko-zwrot i jest dostępna do copy-tradingu lub bezpośredniej inwestycji.',
      darwinex: {
        title: 'Darwinex',
        description: 'Platforma regulowana przez FCA do copy-tradingu strategii algorytmicznych',
        strategies: 'Strategie',
      },
      etoro: {
        title: 'eToro',
        description: 'Platforma social tradingu z milionami użytkowników na całym świecie',
        profile: 'Mój profil',
      },
      wikifolio: {
        title: 'Wikifolio',
        description: 'Europejska platforma dla inwestowalnych certyfikatów strategii',
        profile: 'Mój profil',
      },
      resourcesTitle: 'Zasoby edukacyjne',
      resourcesSubtitle: 'Artykuły, narzędzia i przewodniki do poprawy Twoich inwestycji kwantowych',
      comingSoon: 'Wkrótce',
    },


    // Weekly Reports Page
    weeklyReports: {
      title: 'Tygodniowe raporty kwantowe',
      subtitle: 'Zapisz się na szczegółowe badania kwantowe dla każdej strategii. Każdy raport zawiera dogłębną analizę matematycznego frameworka, tygodniowe rozwoje modelu, ruchy portfela i kwantowe uzasadnienie ewolucji każdej strategii.',
      subscriptionOptions: 'Opcje subskrypcji',
      pricePerMonth: '€{price}/miesiąc',
      subscribe: 'Zapisz się',
      manage: 'Zarządzaj subskrypcją',
      alreadySubscribed: 'Już zapisany',
      signInToSubscribe: 'Zaloguj się, aby zapisać',
      statusActive: 'Aktywny',
      statusCancelling: 'Kończy się {date}',
      statusExpired: 'Wygasło',
      billingMonthly: 'Rozliczenia miesięczne',
      cancelAnytime: 'Anuluj w dowolnym momencie',
      availableOnBrokers: 'Dostępne u wszystkich głównych brokerów',
      assetsLabel: 'Aktywa:',
      whatYouGet: 'Co otrzymujesz:',
      subscribers: '{count} subskrybentów',
      loading: 'Ładowanie...',
      errorLoading: 'Błąd ładowania',
      subscribeTo: 'Zapisz się do',
      subscribed: 'Zapisany',
      cancelsOn: 'Kończy się',
      completeBundle: 'Kompletny pakiet',
      completeBundleDesc: 'Wszystkie strategie + Raporty rynkowe + Quant Macro Insights',
      bestValue: 'NAJLEPSZA WARTOŚĆ',
      perMonth: '/miesiąc',
      perYear: '/rok',
      planMonthly: 'Miesięcznie',
      planAnnual: 'Rocznie',
      twoMonthsFree: '2 miesiące gratis',
      equivMonthly: 'równow. €{price}/miesiąc',
      savingsText: '(€479,92 osobno — oszczędź €184,93 + treści makro)',
      savingsTextAnnual: '(€4.799,92 osobno — oszczędź €1.849,93 + treści makro)',
      getFullAccess: 'Uzyskaj pełny dostęp',
      includes: 'Zawiera:',
      bundleIncludes: {
        strategies: 'Wszystkie 22 strategii (TYR, HRÆSVELGR, ARES, JANUS, BES, FOBOS, DEIMOS, ASCÁLAFO, EOS, ARTEMIS, HELIOS, HYPERION, HORAI, THEIA, ASTRAEUS, PHAETHON, HEMERA, SELENE, ASTERIA, AETHER, HEIMDALL, METIS)',
        weeklyReports: 'Raporty tygodniowe z pełną analizą',
        macroInsights: 'Kwantowe spostrzeżenia makroekonomiczne',
        historicalAccess: 'Pełny dostęp do archiwum historycznego',
        transparentSignals: 'Sygnały z przejrzystym uzasadnieniem',
      },
    },

    // Terminal Page
    terminal: {
      title: 'Terminal',
      watchlist_title: 'Lista obserwowanych',
      add_ticker_placeholder: 'Wpisz ticker + Enter',
      col_symbol: 'Symbol',
      col_price: 'Cena',
      col_change: 'Zmiana',
      col_change_pct: 'Zmiana %',
      col_volume: 'Wolumen',
      col_day_range: 'Zakres dnia',
      footer_text: 'DANE: YAHOO FINANCE · OPÓŹNIENIE 15 MIN · TYLKO DO CELÓW EDUKACYJNYCH',
      // General
      quantLab: 'Laboratorium Kwantowe',
      marketData: 'Dane rynkowe',
      derivatives: 'Instrumenty pochodne',
      signals: 'Sygnały',
      research: 'Badania',
      controls: 'Kontrola',
      statistics: 'Statystyki',
      numPaths: 'Liczba ścieżek',
      seed: 'Ziarno losowe',
      showPaths: 'Pokaż ścieżki',
      showMean: 'Pokaż średnią',
      showDistribution: 'Pokaż rozkład',
      showRegimes: 'Koloruj według reżimu',
      terminalMean: 'Średnia terminowa',
      terminalStd: 'Odch. std. terminowe',
      theoreticalMean: 'Średnia teoretyczna',
      theoreticalStd: 'Odch. std. teoretyczne',
      stationaryMean: 'Średnia stacjonarna',
      stationaryStd: 'Odch. std. stacjonarne',
      pricePaths: 'Ścieżki cen',
      meanReversion: 'Proces powrotu do średniej',
      terminalDistribution: 'Rozkład terminalny',
      priceWithRegimes: 'Ścieżka cen z reżimami rynkowymi',
      regimeStats: 'Statystyki reżimu',
      comingSoon: 'Wkrótce',
      footer: 'Narzędzie edukacyjne do symulacji procesów stochastycznych',
      
      // Modules
      macroTerminal: 'Terminal makro',
      watchlist: 'Lista obserwowanych',
      charts: 'Wykresy',
      heatmap: 'Mapa cieplna',
      optionsPricing: 'Wycena opcji',
      greeks: 'Kalkulator Greeks',
      volatilitySurface: 'Powierzchnia zmienności',
      liveSignals: 'Sygnały na żywo',
      backtest: 'Silnik backtestingu',
      economicCalendar: 'Kalendarz ekonomiczny',
      newsAnalysis: 'Analiza wiadomości',

      // GBM
      gbm: {
        name: 'Geometryczny ruch Browna',
        title: 'Geometryczny ruch Browna',
        subtitle: 'Klasyczny model dynamiki cen akcji ze stałym dryfem i zmiennością',
      },

      // Ornstein-Uhlenbeck
      ou: {
        name: 'Ornstein-Uhlenbeck',
        title: 'Proces Ornsteina-Uhlenbecka',
        subtitle: 'Proces powrotu do średniej używany dla stóp procentowych, zmienności i pair tradingu',
      },

      // Regime Switching
      regime: {
        name: 'Przełączanie reżimu',
        title: 'Model przełączania reżimu',
        subtitle: 'Zachowanie rynku zmienia się pomiędzy reżimami byka, neutralnym i niedźwiedzia',
      },
    },


    // Contact Page
    contact: {
      title: 'Porozmawiajmy',
      subtitle: 'Zainteresowany strategiami kwantowymi, współpracą lub możliwościami zatrudnienia? Skontaktuj się ze mną.',
      formTitle: 'Wyślij mi wiadomość',
      formName: 'Imię',
      formEmail: 'E-mail',
      formMessage: 'Wiadomość',
      formSubmit: 'Wyślij wiadomość',
      infoTitle: 'Informacje kontaktowe',
      emailLabel: 'E-mail',
      emailLocked: 'Wyślij swój e-mail powyżej, aby odblokować',
      linkedinLabel: 'LinkedIn',
      substackLabel: 'Substack',
      fillAll: 'Wypełnij wszystkie pola',
      sent: 'Wiadomość wysłana. Odpowiem wkrótce.',
      sendError: 'Błąd wysyłania wiadomości. Spróbuj ponownie.',
      connectionError: 'Błąd połączenia. Spróbuj później.',
      sending: 'Wysyłanie…',
      methodLabel: 'Metoda kontaktu',
      methodHint: 'Skorzystaj z formularza. Zazwyczaj odpowiadam w ciągu 24–48 godzin.',
    },

    // Returns Calculator Component
    calculator: {
      title: 'KALKULATOR ZWROTÓW',
      subtitle: 'Oblicz, ile byś zarobił inwestując w',
      historicalData: 'z rzeczywistymi danymi historycznymi',
      initialInvestment: 'Inwestycja początkowa',
      monthlyContribution: 'Wpłata miesięczna (Opcjonalna)',
      calculate: 'Oblicz zwroty',
      results: {
        finalValue: 'WARTOŚĆ KOŃCOWA',
        totalGain: 'ZYSK CAŁKOWITY',
        returnPercent: 'ZWROT %',
        summary: 'Podsumowanie:',
        summaryText1: 'Z inwestycją początkową',
        summaryText2: 'i miesięcznymi wpłatami',
        summaryText3: ', zainwestowałbyś łącznie',
        summaryText4: 'w ciągu',
        summaryText5: ', uzyskując wartość końcową',
        years: 'lat',
      },
    },

    // Footer
    footer: {
      rights: 'Wszelkie prawa zastrzeżone',
      disclaimer: 'Przeszłe wyniki nie gwarantują przyszłych rezultatów. Handel wiąże się z ryzykiem.',
      privacy: 'Polityka prywatności',
      terms: 'Warunki korzystania',
      legal: 'Nota prawna',
    },

    // Common
    common: {
      present: 'Obecnie',
      loading: 'Ładowanie...',
      error: 'Błąd',
      success: 'Sukces',
      viewMore: 'Zobacz więcej',
      learnMore: 'Dowiedz się więcej',
      backToTop: 'Powrót na górę',
      downloadBrochure: 'Pobierz broszurę',
    },

    // Terminal Page
    terminal: {
      // Greeks Explorer
      greeksExplorer: {
        name: 'Eksplorator Greeks',
        title: 'GREEKS · WRAŻLIWOŚĆ OPCJI',
        subtitle: 'Jak cena opcji zmienia się przy zmianie danych wejściowych',
        introTitle: 'Wprowadzenie',
        introContent: 'Greeks to pochodne cząstkowe wzoru Black-Scholes. Każdy mówi, jak cena opcji reaguje na zmianę jednego parametru. Profesjonalni traderzy nie patrzą na ceny opcji — patrzą na Greeks. Portfel z Delta = 0 jest "delta-neutralny" — odporny na małe ruchy instrumentu bazowego. Portfel z dodatnim Gamma to "long convexity" — zyskuje na każdym dużym ruchu w górę lub w dół. Zrozumienie Greeks to zrozumienie, jak naprawdę działają opcje.',
        controls: 'Kontrola',
        currentGreeks: 'Aktualne Greeks',
        callOption: 'OPCJA CALL',
        putOption: 'OPCJA PUT',
        price: 'CENA',
        labels: {
          spotPrice: 'S (Cena spot)',
          strike: 'K (Strike)',
          timeToExpiry: 'T (Czas do wygaśnięcia, lata)',
          riskFreeRate: 'r (Stopa wolna od ryzyka)',
          volatility: 'σ (Zmienność)',
        },
        delta: {
          name: 'Δ (DELTA)',
          title: 'Δ (DELTA) · ∂V/∂S',
          description: 'Delta to współczynnik zabezpieczenia. Call z delta 0,5 oznacza, że sprzedajemy krótko 0,5 akcji, aby zabezpieczyć 1 opcję. Delta waha się od 0 do 1 dla call, od -1 do 0 dla put.',
          formula: 'Wzór',
          formulaNote: 'gdzie Φ to dystrybuanta standardowego rozkładu normalnego, a d₁ = [ln(S/K) + (r + σ²/2)T] / (σ√T)',
        },
        gamma: {
          name: 'Γ (GAMMA)',
          title: 'Γ (GAMMA) · ∂²V/∂S² = ∂Δ/∂S',
          description: 'Gamma mierzy, jak szybko zmienia się delta. Wysoka gamma = delta gwałtownie zmienia się przy małych ruchach ceny. Opcje ATM mają najwyższą gammę.',
          formula: 'Wzór',
          formulaNote: 'gdzie φ to funkcja gęstości prawdopodobieństwa standardowego rozkładu normalnego: φ(x) = (1/√(2π)) exp(-x²/2)',
        },
        vega: {
          name: 'V (VEGA)',
          title: 'V (VEGA) · ∂V/∂σ',
          description: 'Vega mierzy wrażliwość na zmienność. Długie opcje = długa zmienność. Jeśli σ wzrośnie o 1%, cena opcji wzrasta o Vega.',
          formula: 'Wzór',
          formulaNote: 'Vega jest taka sama dla call i put. Pokazana dla zmiany zmienności o 1%.',
        },
        theta: {
          name: 'Θ (THETA)',
          title: 'Θ (THETA) · -∂V/∂t',
          description: 'Theta to zanik czasowy. Długie opcje tracą wartość z upływem czasu (ujemna theta). Krótkie opcje zyskują (dodatnia theta) — fundament sprzedaży zmienności.',
          formula: 'Wzór',
          formulaNote: 'Pokazana dziennie. Theta jest zazwyczaj ujemna dla długich opcji (zanik czasowy).',
        },
        rho: {
          name: 'ρ (RHO)',
          title: 'ρ (RHO) · ∂V/∂r',
          description: 'Rho mierzy wrażliwość na stopy procentowe. Dla opcji krótkoterminowych rho jest małe. Dla LEAPS może mieć duże znaczenie.',
          formula: 'Wzór',
          formulaNote: 'Pokazane dla zmiany stopy wolnej od ryzyka o 1%.',
        },
        inStrategies: 'Jak HMA to wykorzystuje',
        fobosStrategy: 'FOBOS aktywnie handluje zmiennością przez opcje. Kluczowym Greekiem dla FOBOS jest Vega — gdy zmienność implikowana jest bogata względem zrealizowanej, FOBOS sprzedaje opcje, aby zbierać premię (ujemna Vega). Gdy implikowana vol spada poniżej zrealizowanej, FOBOS kupuje wypukłość przez długą Gammę.',
        ascalafoStrategy: 'ASCÁLAFO prowadzi systematyczne strategie opcyjne, gdzie dominują Theta i Gamma. Theta to "zysk" ze sprzedaży czasu, ale Gamma to ryzyko — duży ruch wymazuje tygodnie zbierania theta. Sztuka polega na wymiarowaniu pozycji tak, aby stosunek Theta/Gamma był wart ryzyka.',
      },

      // Black-Scholes Derivation
      bsDerivation: {
        name: 'Wyprowadzenie Black-Scholes',
        title: 'BLACK-SCHOLES · OD PIERWSZYCH ZASAD',
        subtitle: 'Jak zbudowano równanie warte Nagrody Nobla',
        tabs: {
          tab1: '01 · PROBLEM',
          tab2: '02 · DWUMIAN',
          tab3: '03 · REPLIKACJA',
          tab4: '04 · CIĄGŁY',
          tab5: '05 · RÓWNANIE RÓŻNICZKOWE',
          tab6: '06 · WZÓR',
        },
        previous: 'POPRZEDNI',
        next: 'NASTĘPNY',
        common: {
          stockPrice: 'Cena akcji',
          strike: 'K',
          strikePrice: 'Cena wykonania',
          spotPrice: 'Cena spot',
          timeToExpiry: 'Czas do wygaśnięcia',
          riskFreeRate: 'Stopa wolna od ryzyka',
          volatility: 'Zmienność',
          initialPrice: 'Cena początkowa',
          upFactor: 'Czynnik wzrostu',
          downFactor: 'Czynnik spadku',
          timeStep: 'Krok czasowy',
          numberSteps: 'Liczba kroków',
          years: 'l',
        },
        tab1: {
          whatIsOption: 'Czym jest opcja?',
          whatIsOptionContent: 'Europejska opcja call daje prawo (nie obowiązek) KUPNA aktywu po ustalonej cenie K w ustalonym dniu T. Jeśli cena aktywu S_T w dniu wygaśnięcia jest powyżej K, realizujesz i inkaszujesz S_T - K. Jeśli poniżej, odchodzisz z zerem.',
          payoffFunction: 'Funkcja wypłaty',
          payoffDesc: 'W dniu wygaśnięcia opcja jest warta swoją wartość wewnętrzną: różnicę między spot a strike, lub zero.',
          interactivePayoff: 'Interaktywny diagram wypłat',
          stockPriceAtExpiry: 'Cena akcji przy wygaśnięciu',
          payoff: 'Wypłata',
          callPayoff: 'Wypłata Call',
          hockeyStick: 'Kształt kija hokejowego: zero poniżej K, liniowy powyżej K. Linia przerywana pokazuje strike.',
          theQuestion: 'Pytanie, na które odpowiada Black-Scholes',
          questionText: 'Ile powinniśmy zapłacić DZIŚ za prawo do otrzymania max(S_T - K, 0) JUTRO?',
          questionExplanation: 'Wypłata jest ZNANA przy danym S_T. Problem polega na tym, że nie znamy S_T. Black-Scholes pokazuje nam, jak zabezpieczyć niepewność całkowicie — przy idealizowanych założeniach — i tym samym ustalić uczciwą cenę opcji.',
          assumptions: 'Założenia',
          assumptionsList: [
            'Akcja podąża za geometrycznym ruchem Browna (zobacz moduł GBM)',
            'Stała zmienność σ',
            'Stała stopa wolna od ryzyka r',
            'Brak dywidend, brak kosztów transakcyjnych, brak podatków',
            'Ciągły handel, doskonała płynność',
            'Wykonanie europejskie (tylko w T, nie wcześniej)',
          ],
        },
        tab2: {simplestUniverse: 'Najprostszy', simplestUniverseContent: 'Krok.', binomialTreeParams: 'Parametry', treeValues: 'Wartości', up: 'GÓRA', down: 'DÓŁ', payoffUp: 'Payoff G', payoffDown: 'Payoff D', wrongApproach: 'BŁĄD', wrongApproachText: 'Średnia:', wrongApproachWarning: 'Źle. REPLIKACJA.'},
        tab3: {centralIdea: 'Idea', centralIdeaContent: 'Portfel.', replicationPortfolio: 'Replikacja', replicationDesc: 'Portfel = Δ + B', solvingSystem: 'Rozwiązanie', hedgeRatio: 'WSKAŹNIK', cash: 'GOTÓWKA', optionPrice: 'CENA', riskNeutralProb: 'Neutralne', riskNeutralText1: 'Algebra:', riskNeutralText2: 'gdzie:', profoundPoint: 'Punkt:', profoundText: 'p nie pojawia się.', riskNeutralQ: 'q:', discountedPrice: 'Cena:'},
        tab4: {nStepIntro: 'N kroków', nStepContent: 'N.', crrParams: 'CRR', crrExplanation: 'GBM.', convergenceTitle: 'Zbieżność', convergenceChart: 'BS.', continuousLimit: 'Granica', continuousLimitContent: 'GBM.'},
        tab5: {derivationIntro: 'Stochastyczny', derivationContent: 'GBM:', itosLemma: 'Itô', itosContent: 'Itô:', hedgePortfolio: 'Portfel', hedgeContent: 'Π = V - Δ·S', noArbitrage: 'Brak Arbitrażu', noArbitrageContent: 'Stopa:', noArbitrageExplanation: 'EDP:', bsPDE: 'EDP', boundaryConditions: 'Warunki', boundaryContent: 'Call:', boundaryList: ['V(S,T)=max(S-K,0)', 'V(0,t)=0)', 'V→S-K·e^(-r(T-t))'], keyInsight: 'Klucz:', keyInsightContent: 'Paraboliczne.'},
        tab6: {closedFormIntro: 'Wzór', closedFormContent: 'Rozwiązanie:', bsFormulaCall: 'BS Call', bsFormulaWhere: 'gdzie:', interactiveCalc: 'Kalkulator', callPrice: 'CALL', putPrice: 'PUT', priceVsSpot: 'Cena', bsPrice: 'BS', intrinsicValue: 'Wewnętrzna', priceChartDesc: 'BS vs wewnętrzna.', impact: 'Wpływ', impactContent: '1973. Nobel.', greeksNext: 'Greeks: pochodne.'},
      },
    },
};
